import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconClock: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99996 1.0415C5.05996 1.0415 1.04163 5.05984 1.04163 9.99984C1.04163 14.9398 5.05996 18.9582 9.99996 18.9582C14.94 18.9582 18.9583 14.9398 18.9583 9.99984C18.9583 5.05984 14.94 1.0415 9.99996 1.0415ZM9.99996 17.7082C5.74913 17.7082 2.29163 14.2507 2.29163 9.99984C2.29163 5.749 5.74913 2.2915 9.99996 2.2915C14.2508 2.2915 17.7083 5.749 17.7083 9.99984C17.7083 14.2507 14.2508 17.7082 9.99996 17.7082ZM12.9417 12.0581C13.1858 12.3023 13.1858 12.6982 12.9417 12.9423C12.82 13.064 12.66 13.1257 12.5 13.1257C12.34 13.1257 12.1799 13.0648 12.0583 12.9423L9.55827 10.4423C9.44077 10.3248 9.37496 10.1657 9.37496 10.0007V5.83398C9.37496 5.48898 9.65496 5.20898 9.99996 5.20898C10.345 5.20898 10.625 5.48898 10.625 5.83398V9.74146L12.9417 12.0581Z"
      fill={color}
    />
  </svg>
);

export default IconClock;
